export class BalanceModel {
  totalBalance: number;
}
